import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import {
    ReactElement,
    HTMLAttributes
} from "react";
import { Arrowdown, Calendar } from "../../assets";
interface Props extends HTMLAttributes<HTMLElement> {
    unread?: boolean;
    title: string;
    description: string;
    date: string;
    time: string;
}

export function AnnouncementsCard({ unread, title, description, date, time }: Props): ReactElement {
    return (
        <div className="announcements-card">
            <Accordion className={`${unread && "unread"} announcements-card-accordion`}>
                <AccordionSummary
                    expandIcon={<Arrowdown/>}
                    aria-controls="panel1a-content"
                    className="summsry"
                    id="panel1a-header"
                >
                    <div className="announcements-card-accordion-headeing">
                        <span className="headeing-title">
                            {title}
                        </span>
                        <div className="text-end">
                            <img src={Calendar} alt="هامرز" className="headeing-img" />
                            <span className="headeing-date">
                                {date}
                            </span>
                            <span className="headeing-date">
                                {time}
                            </span>
                        </div>
                    </div>
                </AccordionSummary>
                <AccordionDetails
                    className="summsry"
                >
                    <p className="announcements-card-accordion-description">
                        {description}
                    </p>
                </AccordionDetails>
            </Accordion>
        </div>
    )
}

export default AnnouncementsCard;